// extracted by mini-css-extract-plugin
export default {"popular_trips":"popularTrips_popular_trips__FWelE"};